import { render } from "./BananaCardItem.vue?vue&type=template&id=054adb00&scoped=true"
import script from "./BananaCardItem.vue?vue&type=script&lang=js"
export * from "./BananaCardItem.vue?vue&type=script&lang=js"

import "./BananaCardItem.vue?vue&type=style&index=0&id=054adb00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054adb00"]])

export default __exports__